import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router} from "@angular/router";
import { Observable  } from 'rxjs';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import { LanguageService } from "@signature-it/ngx-generic/services";

@Injectable({
    providedIn: 'root'
})

export class DocService {
    protected getEntityDocPdfUrl = `${this.config.appURL}/public/entity/get_doc/`;


    constructor(
        protected http: HttpClient,
        protected config: RestUrlsConfig,
        protected router: Router,
        protected langSvc: LanguageService
    ) {}

    getEntityDocPdf(entityType: string, productId: number, queryParams: string): any {
        return this.http.get(`${this.getEntityDocPdfUrl}/${entityType}/${productId}` + (queryParams ? `?${queryParams}` : ''), {responseType: 'blob'});
    }

	getEntityDocViewer(entityType: string, productId: number, queryParams: string): any {
		return this.http.get(`${this.getEntityDocPdfUrl}/${entityType}/${productId}?htmlMode=true` + (queryParams ? `&${queryParams}` : ''));
	}
}
